import React,{useState} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'

import ImagesSlider from '../ui/ImagesSlider'

import Box from '@material-ui/core/Box'
import Markdown from '../ui/Markdown'
import Button from '../ui/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import url from 'rollup-plugin-url';
import Fade from 'react-reveal/Fade';

const styles = theme => ({
    item: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    //    padding: theme.spacing(0, 3),
    },    
    imageCenter:{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      cursor: 'pointer'
    },
    imageCardCenter:{
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    imageCard:{
      maxHeight:'100%',
      maxWidth:'100%',
      objectFit: 'contain',
      width:'100%'
    },
    boxItem:{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'center',
      [theme.breakpoints.down('xs')]:{
        flexDirection: 'column',
        paddingBottom: '10%'
      }
    },
    boxItemCenter:{
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      justifyContent:'center',
      [theme.breakpoints.down('xs')]:{
        
      }
    },
    boxItemRight:{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'center',
      [theme.breakpoints.down('xs')]:{
        flexDirection: 'column-reverse',
        paddingBottom: '10%'
      }
    },
    boxCard:{
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '5%',
      [theme.breakpoints.down('xs')]:{
        width: '100%',
        padding: 0
      }
    },
    boxCardCenter:{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]:{
        width: '100%',
        padding: 0
      }
    },
    imageIcon:{
      backgroundColor: 'silver',
      display: 'inline-block',
      height: 0,
      // paddingBottom: '100%',
      // width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems:'center',
    }
})

const Card = (props) => {

  const {openLink} = props
  const {classes, title, theme, subtitle,body, images, color, variant, image_width, image_position, positionImage, image_alternate_position, item_size, text_alignment, link_to, button_title, button_style, item_spacing, setOpenGallery, itemIndex} = props

  let imageUrl = null
  const [imageWidth,setWidth] = useState(0)
  const [imageHeight,setHeight] = useState(0)
  let height = []

  if (images && images !== undefined && images.length > 0) {
    imageUrl = images[0].image_url
    if (imageUrl.startsWith("/"))
      imageUrl = "http://178.128.86.10:8000" + imageUrl
  }

  const onImgLoad = ({target:img}) => {
    setWidth(img.width)
    setHeight(img.height)
  }

  let imageStyle = []
  let itemStyle = []
  imageStyle['width'] = image_width+'%' || '100%'
  imageStyle['paddingBottom'] = image_width+'%' || '100%'
  imageStyle['background'] = 'url("'+imageUrl+'")'
  imageStyle['backgroundPosition'] = 'center'
  imageStyle['backgroundRepeat'] = 'no-repeat'
  imageStyle['backgroundSize'] = 'contain'

  // itemStyle['padding'] = item_spacing+'%'

  if(item_size === 'xl'){
    if(positionImage === 'left'){
      return (
        <>
        <Fade>
        <Box className={classes.boxItem}>
          <Box className={classes.boxCard}>
          { imageUrl &&
            <Box mb={2} className={classes.imageCenter} onClick={() => setOpenGallery(itemIndex)}>
              <img src={imageUrl} className={classes.imageCard}/>
            </Box>
          } 
          </Box>
          <Box className={classes.boxCard}>
              <Markdown source={ title } color={color} theme={theme}/>
              <Markdown source={ subtitle } color={color} theme={theme}/>
              <Markdown source={ body } color={color} theme={theme}/>
          </Box>
        </Box>
        </Fade>
      </>
      )
    }else{
      return (
        <>
        <Fade>
        <Box className={classes.boxItemRight}>
          <Box className={classes.boxCard}>
              <Markdown source={ title } color={color} theme={theme}/>
              <Markdown source={ subtitle } color={color} theme={theme}/>
              <Markdown source={ body } color={color} theme={theme}/>
          </Box>
          <Box className={classes.boxCard}>
            { imageUrl &&
              <Box mb={2} className={classes.imageCenter}  onClick={() => setOpenGallery(itemIndex)}>
                <img src={imageUrl} className={classes.imageCard}/>
              </Box>
            }
          </Box>
        </Box>
        </Fade>
        
        </>
      )
    }
  }else{
    if(image_position === 'right'){
      return (
        <>
        <Fade>
      <Box className={classes.boxItemRight}>
        <Box className={classes.boxCard}>
            <Markdown source={ title } color={color} theme={theme}/>
            <Markdown source={ subtitle } color={color} theme={theme}/>
            <Markdown source={ body } color={color} theme={theme}/>
        </Box>
        <Box className={classes.boxCard}>
          { imageUrl &&
            <Box mb={2} className={classes.imageCenter}  onClick={() => setOpenGallery(itemIndex)}>
              <img src={imageUrl} className={classes.imageCard}/>
            </Box>
          }
        </Box>
      </Box>
      </Fade>
      
      </>
      )
    }else if(image_position === 'left'){
      return (
        <>
        <Fade>
        <Box className={classes.boxItem}>
          <Box className={classes.boxCard}>
          { imageUrl &&
            <Box mb={2} className={classes.imageCenter} onClick={() => setOpenGallery(itemIndex)}>
              <img src={imageUrl} className={classes.imageCard}/>
            </Box>
          } 
          </Box>
          <Box className={classes.boxCard}>
              <Markdown source={ title } color={color} theme={theme}/>
              <Markdown source={ subtitle } color={color} theme={theme}/>
              <Markdown source={ body } color={color} theme={theme}/>
          </Box>
        </Box>
        </Fade>
        
        </>
      )
    }else{
      return (
        <>
        <Fade>
        <Box className={classes.boxItemCenter} style={itemStyle}>
          <Box className={classes.boxCardCenter}>
            { imageUrl &&
              <Box mb={2} className={classes.imageIcon} style={imageStyle} onClick={() => setOpenGallery(itemIndex)}>
              </Box>
            } 
          </Box>
          <Box>
            <Box className={classes.boxCardCenter}>
                <Markdown source={ title } color={color} theme={theme}/>
                <Markdown source={ subtitle } color={color} theme={theme}/>
                <Markdown source={ body } color={color} theme={theme}/>
            </Box>
          </Box>
        </Box>
        </Fade>
        
        </>
      )
    }
  }
}

export default withStyles(styles, { withTheme: true })(Card);

